import React from "react";
import styles from "./admin-dashboard-page.module.css";

type AdminDashboardPageProps = {};

const AdminDashboardPage = ({}: AdminDashboardPageProps) => {
  return (
    <>
      ADMIN DASHBOARD
    </>
  );
};

export default AdminDashboardPage;